import React from 'react';
import classes from 'classnames';
import styles from './Popup.module.scss';

interface PopupProps {
  open: boolean;
  onClose: () => void;
  onEnable: () => void;
  checked?: boolean;
  onCheck?: (checked: boolean) => void;
  title?: string;
  titleStyle?: React.CSSProperties;
  titleClassName?: string;
  message?: string;
  confirmLabel?: string;
  confirmButtonClassName?: string;
  cancelLabel?: string;
  cancelButtonClassName?: string;
  showCheckbox?: boolean;
  modalStyle?: React.CSSProperties;
  modalClassName?: string;
  contentClassName?: string;
  actionsClassName?: string;
  singleButtonOnly?: boolean;
  isTermsOfUse?: boolean;
  children?: React.ReactNode;
}

const Popup: React.FC<PopupProps> = ({
  open,
  onClose,
  onEnable,
  checked = false,
  onCheck,
  title = 'Terms of Use',
  titleStyle,
  titleClassName,
  message,
  confirmLabel = 'Enable Tutor',
  confirmButtonClassName,
  cancelLabel = 'Cancel',
  cancelButtonClassName,
  showCheckbox = true,
  modalStyle,
  modalClassName,
  contentClassName,
  actionsClassName,
  singleButtonOnly = false,
  isTermsOfUse = false,
  children,
}) => {
  if (!open) return null;

  if (isTermsOfUse) {
    return (
      <div className={styles.overlay}>
        <div className={styles.modal} style={modalStyle}>
          <button className={styles.close} onClick={onClose} aria-label='Close'>
            &times;
          </button>
          <h2 className={styles.title} style={titleStyle}>
            {title}
          </h2>
          <div className={styles.content}>
            <p>
              Lorem ipsum dolor sit amet consectetur. In lacus curabitur malesuada proin vestibulum
              dolor tempus ultricies amet. Nulla diam et condimentum viverra leo pulvinar amet. Mi
              pulvinar diam viverra tincidunt est nunc. Eget gravida magna porttitor mattis etiam
              in. Elit netus et aenean lectus integer nunc nisl aliquam eget. Nibh sit in mattis sed
              amet donec viverra. Turpis duis mus quis nibh in id nunc.
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur. In lacus curabitur malesuada proin vestibulum
              dolor tempus ultricies amet. Nulla diam et condimentum viverra leo pulvinar amet. Mi
              pulvinar diam viverra tincidunt est nunc. Eget gravida magna porttitor mattis etiam
              in. Elit netus et aenean lectus integer nunc nisl aliquam eget. Nibh sit in mattis sed
              amet donec viverra. Turpis duis mus quis nibh in id nunc.
            </p>
            <p>
              Elit netus et aenean lectus integer nunc nisl aliquam eget. Nibh sit in mattis sed
              amet donec viverra. Turpis duis mus quis nibh in id nunc.
            </p>
          </div>
          <div className={styles.actions}>
            <label className={styles.checkboxLabel}>
              <input
                type='checkbox'
                checked={checked}
                onChange={e => onCheck?.(e.target.checked)}
              />
              I Agree the Terms of Use
            </label>
            <button className={styles.enableButton} onClick={onEnable} disabled={!checked}>
              Enable Tutor
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.overlay}>
      <div className={classes(styles.modal, modalClassName)} style={modalStyle}>
        <button className={styles.close} onClick={onClose} aria-label='Close'>
          &times;
        </button>
        <h2 className={classes(styles.title, titleClassName)} style={titleStyle}>
          {title}
        </h2>
        <div className={classes(styles.content, contentClassName)}>
          {children ? children : message && <p>{message}</p>}
        </div>
        <div className={classes(styles.actions, actionsClassName)}>
          {!singleButtonOnly && showCheckbox && onCheck && (
            <label className={styles.checkboxLabel}>
              <input type='checkbox' checked={checked} onChange={e => onCheck(e.target.checked)} />I
              Agree the Terms of Use
            </label>
          )}
          <button
            className={classes(styles.enableButton, confirmButtonClassName)}
            onClick={onEnable}
            disabled={!singleButtonOnly && showCheckbox && !checked}
          >
            {confirmLabel}
          </button>
          {!singleButtonOnly && (
            <button
              className={classes(styles.cancelButton, cancelButtonClassName)}
              onClick={onClose}
            >
              {cancelLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup;
